import { keepOneAndWanOrLine, keepOneOrLine } from '@/utils/utils';
import { V2EnergyOverviewGetWorkOrderDetailPostResponse } from '@maxtropy/device-customer-apis-v2';
import { TaskScene, TaskSceneColors } from '../../../../const';

export const getBarChartOption = (chartData?: V2EnergyOverviewGetWorkOrderDetailPostResponse['chartDetail']) => {
  if (!chartData) return {};

  const categories = chartData.map(m => m.time);

  return {
    backgroundColor: 'transparent',
    color: [TaskSceneColors[TaskScene.ELECTRICITY], TaskSceneColors[TaskScene.WATER], TaskSceneColors[TaskScene.GAS]],
    legend: {
      show: false,
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
      formatter: (items: any) => {
        let { axisValue } = items[0];
        let otherStr = '';
        let str = '';

        items.forEach((item: any) => {
          const { seriesName, data, marker } = item;
          otherStr += `<div style="margin-top:8px;width:100px;"><div style="display:flex;justify-content:space-between;align-items:center;"><div><span>${marker}</span>${seriesName}</div><div>${
            data ?? '-'
          }</div></div>`;
          str = axisValue + otherStr;
        });

        return str;
      },
    },
    grid: {
      left: 10,
      right: 10,
      top: 40,
      bottom: 10,
      containLabel: true,
    },
    xAxis: [
      {
        type: 'category',
        boundaryGap: true, // 或直接删掉
        data: categories,
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: '工单趋势',
      },
    ],
    series: [
      {
        type: 'bar',
        name: '电',
        data: chartData.map(m => m.electricNum ?? 0),

        highlight: {
          focus: 'series',
        },
      },
      {
        type: 'bar',
        name: '水',
        data: chartData.map(m => m.waterNum ?? 0),
      },
      {
        type: 'bar',
        name: '气',
        data: chartData.map(m => m.gasNum ?? 0),
      },
    ],
  };
};
